import React, { Fragment } from 'react'
import { NavLink, Link } from 'react-router-dom'
import FooterArea from '../../../components/FooterArea'

import DocsDestailArea from '../../../components/documentDetail'
import './style.scss'
const DocsDestailAreaPage = () => {
    const [readMore, setReadMore] = React.useState(true);
    return (
        <Fragment>
            
           <DocsDestailArea
           className="SignInArea"
            />
            <FooterArea/>
        </Fragment>
    )
}
export default DocsDestailAreaPage
/* DocsDestailArea */